import { render, staticRenderFns } from "./TwoColBanner.vue?vue&type=template&id=27168d59&scoped=true&"
import script from "./TwoColBanner.vue?vue&type=script&lang=js&"
export * from "./TwoColBanner.vue?vue&type=script&lang=js&"
import style0 from "./TwoColBanner.vue?vue&type=style&index=0&id=27168d59&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27168d59",
  null
  
)

export default component.exports